import { withTranslation } from "react-i18next";
import { useState, useEffect } from "react";
import { Modal } from "antd";

// Inner
import SelectEffect from "./components/SelectEffect";
import SelectPlacements from "./components/SelectPlacements";
import Title from "components/Title";

/**
 * CreateEffect
 * @param {*} props 
 * @returns 
 */
const CreateEffect = (props) => {

  const [selectedEffect, setSelectedEffect] = useState(null);
  const [currentView, setCurrentView] = useState('select-effect');
  const [customizedEffect, setCustomizedEffect] = useState(null);

  useEffect(() => {
    if (selectedEffect) {
      setCustomizedEffect(selectedEffect);
    }
  }, [selectedEffect])

  const _renderView = () => {
    switch (currentView) {
      case 'select-placements':
        return (
          <SelectPlacements
            selectedEffect={selectedEffect}
            customizedEffect={customizedEffect}
            setCustomizedEffect={setCustomizedEffect}
            getEffectUrl={props.getEffectUrl}
            userIris={props.userIris}
            setSelectedMount={props.setSelectedMount}
            resetEnv={() => {props.onOk()}}
          />
        )
      default:
        if (props.totalGeneratedEffects >= props.auth.user.max_photoshop_effects) {
          return (
            <>Vous avez dépassé le nombre d'effets pouvant être créés. Contactez nous pour en créer de nouveaux</>
          )
        }
        return (
          <SelectEffect 
            setSelectedEffect={(effect) => { setSelectedEffect(effect); setCurrentView('select-placements')}}
            selectedEffect={selectedEffect}
            effects={props.effects}
            getEffectUrl={props.getEffectUrl}
            userIris={props.userIris}
          />
        )
    }
  }

  if (!props.effects) {
    return null;
  }

  return (
    <Modal
      visible={props.visible}
      onOk={props.onOk}
      onCancel={props.onCancel}
      footer={null}
      width={'96%'}
      style={{ top: 10, maxWidth: 570 }}
    >
      {
        currentView === 'select-effect' ? (
          <Title style={{ marginBottom: 20, marginTop: -4 }} size={18}>Créer un effet</Title>
        ) : (
          <Title style={{ marginBottom: 18, marginTop: -4 }} size={20}>Choisissez vos iris</Title>
        )
      }

      {
        _renderView()
      }
    </Modal>
  )
}

export default withTranslation()(CreateEffect)